module.exports = __webpack_public_path__ + "img/gem.c1924afa.svg";